export default "__VITE_ASSET__BIJ_vv$A__"